export const printCopy = {
  to: '',
  cc: '',
  bcc: '',
  from: '',
  date: '',
  subject: '',
  noEmailContent: '',
};
